module.exports = __webpack_public_path__ + "static/media/Predni_hora.8fe01dab.md";